"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schroederundpartnerTheme = void 0;
exports.schroederundpartnerTheme = {
    logos: {
        memoresaLogoName: "logo_dark.png",
        memoresaLogotypeName: "logotype_dark.png",
        themeLogoName: ["schroederundpartner.png"],
    },
    background: { main: "#3b4c59" },
    primary: {
        main: "#40515d",
        contrast: "#FFF",
    },
    secondary: {
        main: "#3b4c59",
        contrast: "#FFF",
    },
    navbar: {
        bg: "#3b4c59",
        color: "#005c9c",
        hover: "#005c9c",
    },
};
